/// <reference path="./include/global.d.ts" />

/** Imports */
import { PageAbstract, waitLangText } from './abs/pageAbstract';
import { Buscador } from './include/buscador/buscador';
import { Comentarios } from './include/comentarios';
import { initSucursalesAgencia } from './include/sucursalesAgencia';

/** Dependencias */
import '../stylus/landing.sass'
import '../librerias/OwlCarousel/assets/owl.carousel.min.css'
import '../librerias/OwlCarousel/assets/owl.theme.default.min.css'
import '../librerias/ckeditor5/ckeditor5-content.css'
import 'bootstrap/js/dist/modal'; // modal de login/registro es crítico — no puede esperar al defer
// La parte JS pesada de OwlCarousel y Bootstrap se carga de forma diferida
// cuando realmente se necesita, para reducir Script Evaluation en el primer load.

export class Landing extends PageAbstract {

	/** constructor */
	constructor() {
		super();
	}

	init() {
		// Telemetría: entrada a landing
		(window as any).telemetry?.send('paso1', {
			page_type: 'landing'
		});

		// Web Vitals: capturar métricas de rendimiento
		(window as any).WebVitalsObserver?.captureHomePageVitals((window as any).telemetry, 'landing');

		new Buscador().iniciar();
		this.initCityTextToggle();

		// Landing de agencia: "Ver oferta" de una gama des-minimiza el buscador (ver .buscador-min), sube al tope
		// y oscurece el resto de la página (body.buscador-destacado) para que el buscador sea lo que se ve.
		const setBuscadorExpandido = (expandido: boolean) => {
			$('#h-buscador').toggleClass('buscador-min', !expandido).find('.toggle-buscador').attr('aria-expanded', String(expandido));
			$('body').toggleClass('buscador-destacado', expandido);
		};
		$('body').append('<div class="overlay-buscador"></div>');
		$(document).on('click', '.btn-ver-oferta-gama', () => {
			setBuscadorExpandido(true);
			window.scrollTo({ top: 0, behavior: 'smooth' });
		});
		$(document).on('click', '.toggle-buscador', () => setBuscadorExpandido($('#h-buscador').hasClass('buscador-min')));
		$(document).on('click', '.overlay-buscador', () => setBuscadorExpandido(false));
	}

	loadDeferred() {
		const hasCarousels =
			$(".carousel-carros").length > 0 ||
			$(".carousel-gamas-agencia").length > 0 ||
			$('.carousel-rentadoras').length > 0;

		const loadOwlAndBootstrap = hasCarousels
			? Promise.all([
				import(/* webpackChunkName: "owl-carousel" */ '../librerias/OwlCarousel/owl.carousel.min.js'),
			])
			: Promise.resolve();

		loadOwlAndBootstrap.then(() => {
			import(/* webpackChunkName: "bootstrap-core-landing" */ 'bootstrap/js/dist/carousel')
			import(/* webpackChunkName: "bootstrap-core-landing" */ 'bootstrap/js/dist/collapse');

			// Inicializar carruseles solo cuando la librería esté cargada
			if ($(".carousel-carros").length) {
				this.iniciarCarrousel();
			}
			if ($(".carousel-gamas-agencia").length) {
				this.iniciarCarrouselGamasAgencia();
			}
			if ($('.carousel-rentadoras').length) {
				this.initCarouselMedios();
			}

			this.hoverCards();
			this.initButtonCarrousel();
			this.listenFaqs();
			// Asegurar que x_textos esté disponible antes de llamar a Comentarios
			waitLangText(() => {
				new Comentarios().setVerMas();
			});
			this.addTooltip();

			this.initCarouselCommentsRent();
		});

		this.observeMap();
		initSucursalesAgencia(document.getElementById('sucursales-agencia'), (sucursal) => {
			// Busca en esa sucursal (aeropuerto o ciudad) y filtra los resultados por la rentadora de la página
			const ciudadi = sucursal.idAirport ? sucursal.idAirport + '-2' : sucursal.idCity + '-1';
			const nombre = sucursal.nameAirport || sucursal.nameCity || '';
			$('#ciudadi, #ciudadf').val(ciudadi);
			$('#ciudadi-str, #ciudadf-str').val(nombre);
			this.handleVerOferta(undefined, String(sucursal.idRent));
		});
		this.initBranchOfficesSelector();
	}

	// ponytail: IntersectionObserver nativo, sin librería. loadDeferred() ya dispara en el
	// primer scroll/click, pero eso puede ser un scroll de 50px muy lejos del mapa — acá se
	// arranca la descarga de Leaflet (bundle propio, ver initMap()) justo antes de que el
	// mapa entre en pantalla, no antes. rootMargin da margen para que la descarga termine
	// antes de que el usuario llegue al bloque. Landing puede tener DOS #map posibles (el
	// bloque "sin vehículos" o el nuevo bloque debajo de las cards de rentadora), nunca los
	// dos a la vez — ver pages/inc/sucursales-mapa.blade.php.
	private observeMap(): void {
		const el = document.getElementById('map');
		if (!el) return;

		const load = () => {
			this.initMap().then(() => $('.loading-map').remove());
		};

		if (!('IntersectionObserver' in window)) {
			load();
			return;
		}

		const io = new IntersectionObserver((entries) => {
			if (!entries.some((e) => e.isIntersecting)) return;
			io.disconnect();
			load();
		}, { rootMargin: '200px' });
		io.observe(el);
	}

	initCityTextToggle() {
		const $section = $('#information-city');
		const $text = $section.find('.city-text');
		const $button = $section.find('.city-text-toggle');
		const imageEl = $section.find('.imagen-city img').get(0) as HTMLImageElement | undefined;

		if (!$text.length || !$button.length || !imageEl) return;

		const $label = $button.find('.city-text-label');
		const labels = {
			show: String($button.data('label-show') ?? 'Leer más'),
			hide: String($button.data('label-hide') ?? 'Leer menos')
		};
		const state = { expanded: false };

		const updateButton = () => {
			$button.attr('aria-expanded', String(state.expanded));
			$label.text(state.expanded ? labels.hide : labels.show);
		};

		const sync = () => {
			// Read all geometry first, then write — avoids forced reflow
			const imageHeight = $(imageEl).outerHeight() || 320;
			const scroll = $text[0].scrollHeight;
			const limit = Math.max(imageHeight - 20, 400);
			document.documentElement.style.setProperty('--city-text-max', `${limit}px`);
			$text[0].style.setProperty('--city-text-scroll', `${scroll}px`);
			const needsToggle = scroll > limit + 10;

			$button.toggleClass('is-visible', needsToggle);
			$text.toggleClass('can-collapse', needsToggle);
			if (!needsToggle) {
				state.expanded = false;
				$text.removeClass('expanded');
			}
			updateButton();
		};

		sync();

		const Observer = window.ResizeObserver;
		if (Observer) {
			const resizeObserver = new Observer(() => sync());
			resizeObserver.observe(imageEl);
			resizeObserver.observe($text[0]);
		} else {
			$(window).on('resize.cityText', sync);
			if (!imageEl.complete) $(imageEl).one('load.cityText', sync);
		}

		$button.on('click.cityText', (event) => {
			event.preventDefault();
			state.expanded = !state.expanded;
			$text.toggleClass('expanded', state.expanded);
			updateButton();
		});
	}


	listenFaqs() {
		$('.faq').on('click', function () {
			var $icon = $(this).find('.alk');  // Buscar el elemento i con la clase alk dentro del elemento faq
			// Verificar si el elemento está colapsado
			if ($(this).hasClass('collapsed')) {
				// El elemento está colapsado, cambiar clases del ícono
				$icon.removeClass('alk-angle-up').addClass('alk-angle-down');
			} else {
				// El elemento no está colapsado, cambiar clases del ícono
				$icon.removeClass('alk-angle-down').addClass('alk-angle-up');
			}
		});
	}

	hoverCards() {
		$(".card").on({
			click: function () {
				$(this).toggleClass('active');
			},
			mouseenter: function () {
				$(this).addClass('active');
			},
			mouseleave: function () {
				$(this).removeClass('active');
			}
		});
	}

	initButtonCarrousel() {
		const self = this;
		$(".seleccionar .ver-oferta").on("click", function (e) {
			e.preventDefault();
			e.stopPropagation();
			const selectedGamaId = $(this).data('gama-id');
			const selectedCarCod = $(this).data('selected-car-cod');
			const selectedCarName = $(this).data('selected-car-name');
			const rentadoraId = $(this).parents('.carousel-carros').data('id-rent');
			if (selectedGamaId || selectedCarCod || selectedCarName || rentadoraId) {
				self.handleVerOferta(selectedGamaId, rentadoraId, selectedCarCod, selectedCarName);
			} else {
				$("#buscar").trigger("click");
			}
		});

		$(".link-rentadora").on("click", function () {
			const idRent = $(this).data('id');
			self.handleVerOferta(undefined, idRent);
		});
	}

	/**
	 * Método para iniciar el carrusel de la vista cuadricula
	 * @param {*} map
	 */
	iniciarCarrousel() {
		const carousel = $(".carousel-carros");
		if (carousel.length === 0) return;

		carousel.owlCarousel({
			margin: 10,
			nav: true,
			dots: false,
			loop: false,
			animateOut: "fadeOut",
			navText: [
				'<i id="icon-prev-carros" class="alk alk-angle-left text-primary fs-2" aria-label="Previo" ></i>',
				'<i id="icon-next-carros" class="alk alk-angle-right text-primary fs-2"  aria-label="Siguiente" ></i>',
			],
			responsive: {
				0: {
					items: 1,
				},
				600: {
					items: 3,
				},
				900: {
					items: 4,
				},
				1000: {
					items: 4,
				},
				1200: {
					items: 5,
				},
				1300: {
					items: 6,
				},
			},
		});

		var ariaLabelIcono = $("#icon-prev-carros").attr("aria-label");
		var ariaLabelIconoNext = $("#icon-next-carros").attr("aria-label");

		// Encuentra el botón padre del icono y asigna el mismo aria-label
		$("#icon-prev-carros").parent(".owl-prev").attr("aria-label", ariaLabelIcono ? ariaLabelIcono : '');
		$("#icon-prev-carros").parent(".owl-prev").attr("role", 'button');
		$("#icon-next-carros").parent(".owl-next").attr("aria-label", ariaLabelIconoNext ? ariaLabelIconoNext : '');
		$("#icon-next-carros").parent(".owl-next").attr("role", 'button');
	}

	/**
	 * Carrusel visual de gamas de la landing de agencia (typePage 10): mismo OwlCarousel que
	 * iniciarCarrousel(), pero config propia — sin flechas y con más items (cards más delgadas) — sin
	 * tocar el carrusel de precios de las páginas de ciudad, que usa su propia clase/config.
	 */
	iniciarCarrouselGamasAgencia() {
		const carousel = $(".carousel-gamas-agencia");
		if (carousel.length === 0) return;

		// Flechas solo con 10 gamas o más, para que se entienda que es un carrusel. La clase le
		// abre espacio a los lados (landing.sass) para que las flechas queden fuera de las cards.
		const conFlechas = carousel.children().length >= 10;
		carousel.toggleClass('con-flechas', conFlechas);

		carousel.owlCarousel({
			margin: 10,
			nav: conFlechas,
			navText: [
				'<i class="alk alk-angle-left text-primary" aria-label="Previo"></i>',
				'<i class="alk alk-angle-right text-primary" aria-label="Siguiente"></i>',
			],
			dots: false,
			loop: false,
			responsive: {
				0: { items: 2 },
				600: { items: 4 },
				900: { items: 5 },
				1000: { items: 6 },
				1200: { items: 7 },
				1300: { items: 8 },
			},
		});
	}

	initCarouselMedios() {
		$('.carousel-rentadoras')?.owlCarousel({
			loop: false,
			nav: true,
			dots: false,
			margin: 6,
			navText: [
				'<i id="icon-prev-rentadoras" class="alk alk-angle-left text-primary" aria-label="Previo"></i>',
				'<i id="icon-next-rentadoras" class="alk alk-angle-right text-primary" aria-label="Siguiente"></i>',
			],
			responsive: {
				0: {
					items: 1
				},
				600: {
					items: 3
				},
				1000: {
					items: 4
				}
			}
		});

		var ariaLabelIcono = $("#icon-prev-rentadoras").attr("aria-label");
		var ariaLabelIconoNext = $("#icon-next-rentadoras").attr("aria-label");

		// Encuentra el botón padre del icono y asigna el mismo aria-label
		$("#icon-prev-rentadoras").parent(".owl-prev").attr("aria-label", ariaLabelIcono ? ariaLabelIcono : '');
		$("#icon-prev-rentadoras").parent(".owl-prev").attr("role", 'button');
		$("#icon-next-rentadoras").parent(".owl-next").attr("aria-label", ariaLabelIconoNext ? ariaLabelIconoNext : '');
		$("#icon-next-rentadoras").parent(".owl-next").attr("role", 'button');
	}

	addTooltip() {
		const tooltips = document.querySelectorAll('[data-tooltip]');
		tooltips.forEach(tooltip => {
			tooltip.addEventListener('mouseenter', () => {
				const tooltipText = tooltip.getAttribute('data-tooltip');
				if (tooltipText) {
					const tooltipElement = document.createElement('div');
					tooltipElement.className = 'custom-tooltip';
					tooltipElement.textContent = tooltipText;
					document.body.appendChild(tooltipElement);

					// Usar requestAnimationFrame para agrupar DOM reads y writes
					requestAnimationFrame(() => {
						const rect = tooltip.getBoundingClientRect();
						tooltipElement.style.left = `${rect.left + window.scrollX}px`;
						tooltipElement.style.top = `${rect.bottom + window.scrollY + 5}px`;
					});

					tooltip.addEventListener('mouseleave', () => {
						tooltipElement.remove();
					});
				}
			});
		});
	}

	async initMap() {
		try {
			const divMap = $('#map');
			if (divMap.length === 0) return;

			divMap[0].addEventListener('wheel', (e) => { e.preventDefault(); }, { passive: false });

			const rawCityMap = divMap.data('map');
			const rawOffices = divMap.data('offices');

			if (!rawCityMap || !rawOffices) {
				console.warn('Map data missing');
				return;
			}
			const cityMap = JSON.parse(this.utils.decompressEncodedURI(rawCityMap));
			const offices = JSON.parse(this.utils.decompressEncodedURI(rawOffices));

			const lat = Number(cityMap.lat);
			const lng = Number(cityMap.lng);

			if (isNaN(lat) || isNaN(lng)) {
				console.warn('Invalid city coordinates');
				return;
			}

			await import('leaflet/dist/leaflet.css');
			const L = await import('leaflet');

			let map = L.map(divMap[0], {
				center: [lat, lng],
				zoom: 11,
				zoomControl: true,
				scrollWheelZoom: true
			});

			const tileLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
				{
					attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
					maxZoom: 19,
					minZoom: 3,
					detectRetina: true
				}
			);
			tileLayer.addTo(map);

			offices.forEach((office: any) => {
				if (isNaN(office?.latitude) || isNaN(office?.longitude))
					return;

				const iconImg = `<img src="${office.imgRentMap}" alt="${office.nameRent}" width="40" height="40">`;

				let customIcon = L.divIcon({
					className: 'icon-marker',
					html: iconImg,
					iconSize: [40, 40],
					iconAnchor: [20, 40],
					popupAnchor: [0, -40]
				});

				const markerPoint = L.marker([office.latitude, office.longitude], { icon: customIcon }).addTo(map);
				let popupHtml = `
					<div class="info-marker">
						<img src="${office.imageRent}" alt="${office.nameRent}" title="${office.nameRent}">
						<br>
						<span>
							<strong>${x_textos?.["M154-0"]}:</strong><br>
							${office.addressOffice}
						</span>
						<br>
					</div>
				`;
				markerPoint.bindPopup(popupHtml, {
					closeButton: true,
					autoPan: true,
					maxWidth: 200
				});
			});
		} catch (error) {
			console.error(
				`Error function(initMap): '${error}'`
			);
			console.error('Error in load map', error);
		}
	}

	/**
	 * Maneja el clic en "ver oferta" para redirigir al paso 2
	 */
	handleVerOferta(selectedGamaId?: string, rentadoraId?: string, selectedCarCod?: string, selectedCarName?: string) {
		const $form = $('#form-busqueda');
		let searchUrl = $form.attr('action') + '?' + $form.serialize();
		if (selectedGamaId) searchUrl += '&gama-selected=' + selectedGamaId;
		if (rentadoraId) searchUrl += '&filter-rent=' + rentadoraId;
		if (selectedCarCod) searchUrl += '&selected-car-cod=' + selectedCarCod;
		if (selectedCarName) searchUrl += '&selected-car-name=' + encodeURIComponent(String(selectedCarName));

		// TELEMETRÍA: intento_busqueda
		const searchParams = {
			lugar: $('#ciudadi-str').val() || $('#ciudadi').val(),
			fecha_inicio: $('#fecha-ini').val(),
			fecha_fin: $('#fecha-fin').val()
		};
		(window as any).telemetry?.send('intento_busqueda', {
			origin: 'landing',
			search_params: searchParams
		});

		window.location.href = searchUrl;
	}


	initCarouselCommentsRent() {
		const $carousel = $('#carousel-testimonios-rent');
		const $parent = $carousel.parents('#testimonios');
		const idRent = $parent.data('id-rent');
		if (!idRent) return;

		$parent.removeClass('d-none');
		const itemTemplate = $carousel.find('.testimonio-item').first().prop('outerHTML');
		const loadingTemplate = $carousel.find('.testimonio-loading').first().prop('outerHTML');
		const carouselItemTemplate = $carousel.find('.carousel-item').first().empty().prop('outerHTML');

		const $carouselInner = $carousel.find('.carousel-inner').html('');

		const createLoadingPage = (page: number, active = false): JQuery<HTMLElement> => {
			const $page = $(carouselItemTemplate)
				.data('page', page)
				.toggleClass('active', active)
				.append('<div class="row d-flex justify-content-center"></div>');

			const $row = $page.children('.row');
			for (let i = 0; i < 6; i++) {
				$row.append(loadingTemplate);
			}
			return $page;
		};

		const buildCommentHtml = (comment: any): JQuery<HTMLElement> => {
			let html = itemTemplate
				.replace('{nombCalif}', `${comment.nameUsuario ?? ''} ${comment.apellUsuario ?? ''}`.trim() || x_textos['583-1'])
				.replace('{fechaCalif}', comment?.dateCalif || '')
				.replace('{commentCalif}', comment?.commentCalif || 'Sin Comentarios');

			const $html = $(html);
			$html.find('.estrellas').html(
				Array.from({ length: 5 }, (_, i) => `<i class="alk alk-${(comment.valCalif ?? 0) >= i + 1 ? 'star' : 'star-o'}"></i>`).join('')
			);
			if ((comment?.mImg ?? 0) != 0 && comment?.displayBig) {
				$html.find('img').attr('src', comment.displayBig);
			}
			return $html;
		};

		const loadComments = ($page: JQuery<HTMLElement>): void => {
			if (!$page || $page.hasClass('rendered') || $page.hasClass('rendering')) return;
			$page.addClass('rendering');

			const page = Number($page.data('page'));

			const config = { dir: '/action/getComments/', type: 'POST' };
			const params = { idRentadora: idRent, pagina: page, pageSize: 6, publicas: 1 };

			this.utils.jSONInfo(config, params, (data: any) => {
				const comments = (data?.ans?.comentarios ?? []) as any[];
				const $row = $page.find('.row').empty();

				if (page == 1 && !comments.length) {
					$parent.addClass('d-none');
				}

				comments.forEach((comment: any) => {
					$row.append(buildCommentHtml(comment));
				});

				$page.removeClass('rendering');
				$page.addClass('rendered');

				const nextPage = Number(data?.ans?.comentariosNextPage);
				if (!isNaN(nextPage) && nextPage > 0) {
					$carouselInner.append(createLoadingPage(nextPage));
				}

				new Comentarios().setVerMas();
			});
		};

		const $firstPage = createLoadingPage(1, true);
		$carouselInner.append($firstPage);
		loadComments($firstPage);

		$carousel.on('slid.bs.carousel', () => {
			loadComments($carousel.find('.carousel-item.active'));
		});
	}

	/**
	 * Selector "Rentadora" + tarjetas de sucursal del bloque "sin vehículos" (#branch-cards-container).
	 * Portado de paso2.ts (initBranchOfficesSelector/showBranchCards/generate*Html) — misma lógica,
	 * pero la data viaja en el atributo `data-offices` del propio contenedor (comprimida, mismo
	 * mecanismo que ya usa #map), no en el global window.branchOfficesData que usa paso2.
	 */
	initBranchOfficesSelector() {
		const $container = $('#branch-cards-container');
		if ($container.length === 0) return;

		const raw = $container.data('offices');
		let branchOfficesGrouped: any[] = [];
		try {
			branchOfficesGrouped = raw ? JSON.parse(this.utils.decompressEncodedURI(raw)) : [];
		} catch (error) {
			console.error('Error parsing branchOfficesGrouped', error);
			return;
		}
		if (!Array.isArray(branchOfficesGrouped) || branchOfficesGrouped.length === 0) return;

		const container = $container[0];
		const selector = document.getElementById('rentadora-select') as HTMLSelectElement | null;

		if (selector) {
			selector.addEventListener('change', (event) => {
				const selectedRentId = (event.target as HTMLSelectElement).value;
				this.showBranchCards(selectedRentId, container, branchOfficesGrouped);
			});
			const firstOption = selector.querySelector('option[value]:not([value=""])') as HTMLOptionElement;
			if (firstOption) {
				selector.value = firstOption.value;
				this.showBranchCards(firstOption.value, container, branchOfficesGrouped);
			}
		} else {
			// Página de ciudad+rentadora (typePage 5/8): sin selector, solo hay un grupo — se muestra directo.
			const first = branchOfficesGrouped[0]?.[0];
			if (first) this.showBranchCards(String(first.idRent), container, branchOfficesGrouped);
		}
	}

	private showBranchCards(rentId: string, container: HTMLElement, branchOfficesGrouped: any[]): void {
		if (!rentId) {
			const msg = alk_lang === 'en' ? 'Select a rental company to see its branch offices' : 'Selecciona una rentadora para ver sus sucursales';
			container.innerHTML = `<p class="text-muted text-center">${msg}</p>`;
			return;
		}

		const branches = branchOfficesGrouped.find((group: any) => {
			if (!Array.isArray(group) || group.length === 0) return false;
			return String(group[0].idRent) === String(rentId);
		});

		if (!branches || branches.length === 0) {
			const msg = alk_lang === 'en' ? 'No branch offices found for this rental company' : 'No se encontraron sucursales para esta rentadora';
			container.innerHTML = `<p class="text-muted text-center">${msg}</p>`;
			return;
		}

		const cardHtml = branches.length === 1
			? this.generateSingleBranchCardHtml(branches[0], this.generateBranchHoursHtml(branches[0]))
			: this.generateBranchCarouselHtml(branches, rentId);

		container.innerHTML = cardHtml;

		if (branches.length > 1) {
			this.initializeBranchCarousels(container);
		}
	}

	private static escHtml(s: string): string {
		return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	}

	private generateBranchHoursHtml(branch: any): string {
		const lang = alk_lang || 'es';
		const raw = branch.openingHours?.[lang];
		if (!raw) return '<div class="hour-row" style="color: #666;">Horarios no disponibles</div>';
		if (typeof raw === 'string') return `<div class="hour-row">${raw}</div>`;

		const days: Array<{ nameDay: string; hours?: Array<{ opens: string; closes: string }> }> =
			Array.isArray(raw)
				? raw
				: Object.entries(raw).map(([key, val]: [string, any]) => ({
					nameDay: val?.nameDay || key,
					hours: val?.hours,
				}));

		return days.map(day => {
			const hours = day.hours?.length
				? day.hours.map(h => `${h.opens}-${h.closes}`).join('/')
				: 'Cerrado';
			return `<div class="hour-row"><span class="day-name">${day.nameDay}:</span><span class="day-hours">${hours}</span></div>`;
		}).join('');
	}

	private generateSingleBranchCardHtml(branch: any, hoursHtml: string): string {
		const e = Landing.escHtml;
		return `
			<div class="branch-card mb-4">
				<div class="branch-header">
					<img src="${e(branch.imageRent)}" alt="${e(branch.nameRent)}">
					<div class="branch-info">
						<h6>${e(branch.nameRent)}</h6>
						<p>${e(branch.addressOffice)}</p>
					</div>
				</div>
				<div class="branch-hours">
					${hoursHtml}
				</div>
			</div>
		`;
	}

	private generateBranchCarouselHtml(branches: any[], rentId: string): string {
		const carouselId = `branchCarousel-${rentId}`;
		const e = Landing.escHtml;
		let carouselItemsHtml = '';
		let indicatorsHtml = '';

		branches.forEach((branch: any, index: number) => {
			const hoursHtml = this.generateBranchHoursHtml(branch);
			const isActive = index === 0;
			const activeClass = isActive ? 'active' : '';

			carouselItemsHtml += `
				<div class="carousel-item ${activeClass}">
					<div class="branch-card-content">
						<div class="branch-header">
							<img src="${e(branch.imageRent)}" alt="${e(branch.nameRent)}">
							<div class="branch-info">
								<h6>${e(branch.nameRent)}</h6>
								<p>${e(branch.addressOffice)}</p>
							</div>
						</div>
						<div class="branch-hours">
							${hoursHtml}
						</div>
					</div>
				</div>
			`;
			indicatorsHtml += `
				<button type="button" data-bs-target="#${carouselId}" data-bs-slide-to="${index}"
					class="${activeClass}" aria-label="Sucursal ${index + 1}"
					${isActive ? 'aria-current="true"' : ''}></button>
			`;
		});

		// Mismo patrón que src/ts/paso2.ts::generateBranchCarouselHtml() — botones circulares
		// con el ícono propio del proyecto (alk-angle-*), en línea con los dots, en vez de las
		// flechas por defecto de Bootstrap (position:absolute sobre los bordes, invisibles en
		// blanco sin el fix de filter:invert). CSS también portado 1:1 (.branch-carousel-nav)
		// a src/stylus/landing.sass, no reinventado.
		return `
			<div class="branch-card mb-4">
				<div id="${carouselId}" class="carousel slide branch-carousel">
					<div class="carousel-inner">
						${carouselItemsHtml}
					</div>
					<div class="branch-carousel-nav">
						<button class="carousel-control-prev btn" type="button"
							data-bs-target="#${carouselId}" data-bs-slide="prev"
							aria-label="${alk_lang === 'en' ? 'Previous branch' : 'Sucursal anterior'}">
							<i class="alk alk-angle-left"></i>
						</button>
						<div class="carousel-indicators">
							${indicatorsHtml}
						</div>
						<button class="carousel-control-next btn" type="button"
							data-bs-target="#${carouselId}" data-bs-slide="next"
							aria-label="${alk_lang === 'en' ? 'Next branch' : 'Sucursal siguiente'}">
							<i class="alk alk-angle-right"></i>
						</button>
					</div>
				</div>
			</div>
		`;
	}

	// bootstrap/js/dist/carousel normalmente se carga recién en loadDeferred() (primer scroll/click),
	// pero este bloque puede mostrarse antes de esa interacción — mismo criterio que initMap() con
	// Leaflet: importar la dependencia en el momento exacto que se necesita, sin esperar el defer.
	private async initializeBranchCarousels(container: HTMLElement): Promise<void> {
		const { default: Carousel } = await import(/* webpackChunkName: "bootstrap-core-landing" */ 'bootstrap/js/dist/carousel');
		container.querySelectorAll('.carousel').forEach((carousel) => {
			new Carousel(carousel, { interval: false, wrap: true });
		});
	}
}

var landingInstance: Landing;
var landingDeferredHandled: boolean = false;

$(function () {
	landingInstance = new Landing();
	waitLangText(() => {
		landingInstance.init();
	});
});

const landingHandleFirstInteraction = () => {
	if (!landingDeferredHandled && landingInstance) {
		landingDeferredHandled = true;
		landingInstance.loadDeferred();
		window.removeEventListener('scroll', landingOnScroll, { capture: true } as any);
		document.removeEventListener('click', landingOnClick, true);
	}
};

const landingOnScroll = () => landingHandleFirstInteraction();
const landingOnClick = () => landingHandleFirstInteraction();

window.addEventListener('scroll', landingOnScroll, { passive: true });
document.addEventListener('click', landingOnClick, true);


